import {client} from "../utils/axios";

export type  Employee = {
    user_id: number,
    fname: string,
    mname?: string,
    lname: string,
    shop_floor_work_station: string,
    email: string,
    position: string,
    rank: string,
    role: string,
    jd: string,
    signature: string,
    work_station: string,
    tel: string,
    ip_phone: string,
    live_type: string,
    on_live: boolean,
    sSupervisor?: number,
    supervisor?: number,
    profile_photo?: string,
    department: number
    division?: number
    sub_department?: number
    unit?: number
    password: string,
};

export type  EmployeeDB = {
    id: number,
    fname: string,
    mname: {
        "String": string,
        Valid: boolean,
    },
    lname: string,
    email: string,
    position: string,
    profile_photo: {
        "String": string,
        Valid: boolean,
    },
    jd: string,
    tel: string,
    iphone: string,
    shop_floor_work_station: string,
    work_station: string,
    sSupervisor: EmployeeDB,
    supervisor: EmployeeDB,
    rank: string,
    role: string,
    live_type: string,
    on_live: boolean,
    signature: string,
    department_id: number
    division_id: {
        Int64: number,
        Valid: boolean,
    },
    supervisor_l_id: {
        Int64: number,
        Valid: boolean,
    }
    s_supervisor_id: {
        Int64: number,
        Valid: boolean,
    }
    sub_department_id: {
        Int64: number,
        Valid: boolean,
    }
    unit_id: {
        Int64: number,
        Valid: boolean,
    }
    password: string,
};

export type AddEmployee = {
    fname: string,
    mname?: string,
    lname: string,
    email: string,
    password: string,
};

export type EmployeeLogin = {
    email: string,
    password: string,
}


export const loginService = async (cred: EmployeeLogin) => {
    return await client
        .post("login", {
            email: cred.email.trim(),
            password: cred.password.trim(),
        });

};

export const changePasswordService = async (token: string, password: string) => {
    return await client
        .post(`changePassword/${token}`, {
            password: password.trim()
        });
};

export const checkTokenValidService = async (token: string, password: string) => {
    return await client
        .post(`checkTokenValid/${token}`, {
            password: password.trim()
        });
};

export const forgotPasswordService = async (email: string) => {
    return await client
        .post("forgotPassword", {
            email: email.trim(),
        });
};

export const LogoutService = async () => {
    return await client.post("logout")
};